<template>
  <div class="comp-side-nav">
    <ul>
      <li
        v-for="(item, i) in data"
        :key="i"
        :class="{ active: $route.path == item.link }"
      >
        <router-link :to="item.link">{{ item.name||item.title }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "side-nav",
  props: {
    data: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-side-nav {
  line-height: 56px;
  font-size: 15px;
  li {
    width: 200px;
    height: 56px;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
    padding-left: 40px;
    box-sizing: border-box;
    position: relative;
    &::before {
      content: " ";
      width: 0;
      height: 2px;
      vertical-align: bottom;
      display: inline-block;
      background-color: $primary-color;
      position: absolute;
      bottom: 0;
      transition: width 0.3s ease-in;
    }
    &:hover,
    &.active {
      a {
        color: $primary-color;
      }
      &::before {
        width: 30px;
      }
    }
  }
}
</style>
